






import { Vue, Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'SubmitBtn'
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }
}

